<template>
	<div class="company">
		<div>
			<LeftDropDownMenu :MenuList="MenuList"></LeftDropDownMenu>
			<div class="Menuline">
			</div>
			<div class="router">
				<router-view ref="routers"></router-view>
			</div>
		</div>
		<TipsDialog isOpen />
	</div>
</template>

<script>
	import LeftDropDownMenu from '../components/leftDropDownMenu/leftDropDownMenu.vue'
	import TipsDialog from './components/TipsDialog.vue'
	import {
		UserInfoLicenseMenu
	} from '@/api/channel'
	export default {
		components: {
			LeftDropDownMenu,
			TipsDialog
		},
		data() {
			return {
				MenuList: [],
				CusWebMenus: [],
				Menus: null,
				IDArr: [],
				List: []
			}
		},
		mounted() {
			// let json = JSON.parse(localStorage.getItem("vuex"));
			// if (json && json.userInfo.IsAppCustomer) {
			// 	this.$alert('请配合完成公司信息的填报！', '提示', {
			// 		confirmButtonText: '确定',
			// 		callback: action => {}
			// 	});
			// }
			this.MenusList()
		},
		methods: {
			MenusList() {
				// 获取渠道管理全部菜单
				this.CusWebMenus = JSON.parse(localStorage.getItem("MenusData")).CusWebMenus
				// 截取URL的MenuID
				let index = window.location.hash.lastIndexOf("?")
				let par = window.location.hash.substring(index + 1, window.location.hash.length);
				let pars = par.substring(0, 6)
				let MenuID = par.substring(par.lastIndexOf("=") + 1, par.length);
				// // 过滤获取到对应的菜单
				this.Menus = this.CusWebMenus.filter(item => item.NodeID == 61)
				// // 获取菜单列表MenuID
				this.MenuList = this.Menus[0].Nodes
				this.userInfoLicenseMenu()
			},
			async userInfoLicenseMenu() {
				let {
					code,
					data,
					message
				} = await UserInfoLicenseMenu({})
				if (code == 0) {
					this.List = data;
					console.log(66666, this.MenuList, data);
					this.MenuList.map((item, index) => {
						console.log(item, 'item');
						if (item.NodeID == '68') {
							// item.Nodes = []
							item.Nodes.map(it => {
								it.LicenseStatus = this.List[this.getLicenseStatus(it.NodeID)]
									.LicenseStatus;
								console.log(it.LicenseStatus);
								return it;
							})
						}
						return item;
					})
					console.log(this.List, 'this.List');
				} else {
					this.$notify.error({
						title: '提示',
						message: message
					})
				}
			},
			//获取状态
			getLicenseStatus(id) {
				return this.List.findIndex(it => it.NodeID === id);
			}
		}
	}
</script>

<style lang="less" scoped>
	.company {
		width: 1200px;
		min-height: 500px;
		background: #ffffff;
		border: 1px solid #e6e8eb;
		margin-top: 16px;
		margin-right: auto;
		margin-bottom: 100px;
		margin-left: auto;
		padding-top: 20px;
		padding-bottom: 40px;
		position: relative;
		top: 16px;
		user-select: none;

		.router {
			// border: 1px solid #00266d;
			width: 940px;
			height: 100%;
			position: relative;
			left: 255px;
			// top: 20px;
		}
	}

	.Menuline {
		width: 1px;
		min-height: 96%;
		background-color: #e6e8eb;
		display: inline-block;
		position: absolute;
		left: 255px;
	}
</style>